import React from 'react';
import ImageGalleryexhibition from '../components/ImageGalleryexhibition';
import IRCTVDonationCard from "./IRCTVDonationCard";

const IRCEXHIBITION = () => {
      const charityBaseAmount = 5000;

    return (
        <>
            <div className="about-us-container">
                <section className="activities-details">
           <button 
          onClick={() => window.history.back()}
          style={{
            marginBottom: '10px',
            padding: '8px 10px',
            backgroundColor: '#255fe8',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          ← Back to All Activities
        </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>
                            All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
                        </p>
                    </div>

                    <ImageGalleryexhibition />

                    {/* IRC 10 Days WEEKLY */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>IRC EXHIBITION & MUSEUM</h3>
                        </div>
                        <div className="activity-content">
                            <p>
                                IRC organizes exhibitions on different themes such as Quran & Modern Science, Muslim Scientists, Islamic Civilizatin, Books, Social & Moral Evils, Coins, Currecy, Stamps etc. These exhibitions are conducted independently or through sponsorship. Kindly contact IRC office for details.


                            </p>
                        </div>
                                    <IRCTVDonationCard 
               title="IRC EXHIBITION & MUSEUM"
                             baseAmount={charityBaseAmount}

              subtitle="Your donation makes a difference"
              description="Donate Us continue providing quality content and services to our community."
              amount="₹5000"
              purpose="Cause: IRC EXHIBITION & MUSEUM"
            />
                    </div>
                </section>
            </div>
        </>
    );
};

export default IRCEXHIBITION;
